import Page from "src/components/Report/Page"
import jobContext from "../../../context/jobContext"
import { useContext } from "react"

function GreadingPage({ pageNumber, employeeScore = false, type = 1 }) {

    const { greadingScore } = useContext(jobContext)
    const maharat = (+greadingScore?.education || 0) + (+greadingScore?.experience || 0) + (+greadingScore?.majmooeTavanmadiha || 0)

    const masoliat = (+greadingScore?.masouliatAmvalVaTajhizat || 0) + (+greadingScore?.masouliatManabeMali || 0) +
        (+greadingScore?.forms || 0) +
        (+greadingScore?.gDamaneErtebati || 0) +
        (+greadingScore?.masouliatMoghararat || 0) +
        (+greadingScore?.argonomi || 0) +
        (+greadingScore?.azadiAmal || 0) +
        (+greadingScore?.halemasale || 0) +
        (+greadingScore?.pasokhgooyi || 0) +
        (+greadingScore?.masoliatKhas || 0) +
        (+greadingScore.sarparastiGheireMostaghim || 0) +
        (+greadingScore.sarparastiMostaghim || 0)

    const kooshesh = (+greadingScore?.koosheshFekri || 0) +
        (+greadingScore?.koosheshEhsasi || 0) +
        (+greadingScore?.koosheshJesmi || 0)


    const sharayet = (+greadingScore?.khataratNashiAzKar || 0) + (+greadingScore?.sharayeteNamosaedeMohiteKar || 0) + (+greadingScore?.stress || 0)


    const greadingData = [
        {
            name: "مهارت ها", score: "350", jobScore: maharat, employeeScore: "", items: [
                { name: "تحصیلات", score: "200", jobScore: greadingScore?.education, employeeScore: "" },
                { name: "تجربیات", score: "120", jobScore: greadingScore?.experience, employeeScore: "" },
                { name: "گواهینامه های مهارتی", score: "30", jobScore: greadingScore?.majmooeTavanmadiha, employeeScore: "" },
            ]
        },

        {
            name: "اختیارات و مسئولیت ها", score: "380", jobScore: masoliat, employeeScore: "", items: [
                { name: "منابع انسانی", score: "40", jobScore: greadingScore?.sarparastiGheireMostaghim + greadingScore?.sarparastiMostaghim, employeeScore: "" },

                { name: "منابع فیزیکی", score: "30", jobScore: greadingScore?.masouliatAmvalVaTajhizat, employeeScore: "" },

                { name: "منابع مالی", score: "40", jobScore: greadingScore?.masouliatManabeMali, employeeScore: "" },

                { name: "فرم ها و گزارشات", score: "30", jobScore: greadingScore?.forms, employeeScore: "" },

                { name: "ارتباط با دیگران", score: "40", jobScore: greadingScore?.gDamaneErtebati, employeeScore: "" },

                { name: "مقررات، روش‌ها و سیستم‌ها", score: "30", jobScore: greadingScore?.masouliatMoghararat, employeeScore: "" },

                { name: "ایمنی، بهداشت، محیط و ارگونومی", score: "30", jobScore: greadingScore?.argonomi, employeeScore: "" },

                { name: "استقلال و آزادی عمل", score: "40", jobScore: greadingScore?.azadiAmal, employeeScore: "" },

                { name: "حل مساله و تصمیم گیری", score: "40", jobScore: greadingScore?.halemasale, employeeScore: "" },

                { name: "پاسخگویی", score: "400", jobScore: greadingScore?.pasokhgooyi, employeeScore: "" },

                { name: "مسئولیت خاص", score: "20", jobScore: greadingScore?.masoliatKhas, employeeScore: "" },
            ]
        },



        {
            name: "کوشش ها", score: "150", jobScore: kooshesh, employeeScore: "", items: [
                { name: "کوشش فکری،دقت و تمرکز", score: "60", jobScore: greadingScore?.koosheshFekri, employeeScore: "" },
                { name: "کوشش احساسی", score: "40", jobScore: greadingScore?.koosheshEhsasi, employeeScore: "" },
                { name: "کوشش جسمانی", score: "50", jobScore: greadingScore?.koosheshJesmi, employeeScore: "" },
            ]
        },
        {
            name: "شرایط کار", score: "120", jobScore: sharayet, employeeScore: "", items: [
                { name: "خطرات ناشی از کار", score: "40", jobScore: greadingScore?.khataratNashiAzKar, employeeScore: "" },
                { name: "شرایط نامساعد محیط کار", score: "40", jobScore: greadingScore?.sharayeteNamosaedeMohiteKar, employeeScore: "" },
                { name: "استرس و شرایط غیرعادی کار", score: "40", jobScore: greadingScore?.stress, employeeScore: "" },
            ]
        },
    ]




    return (
        <Page pageNumber={pageNumber}>
            {
                type == 1
                    ?
                    <>
                        <h2 className="text-xl text-bold">نتیجه کلی ارزیابی ابعاد و مولفه‌های گریدینگ شغل (مبتنی بر مدل G20)</h2>
                        <p>نتایج ارزیابی شغل جهت گریدینگ و تخصیص حقوق و دستمزد به شرح زیر میباشد</p>
                    </>
                    :
                    <>
                        {/* <h2 className="text-xl text-bold">فرم تطبیق امتیاز شاغل مبتنی بر گریدینگ شغل</h2> */}
                    </>
            }

            <table className="border border-gray-300">
                <thead>
                    <tr className="">
                        <th className="py-4">عوامل (معیارها)</th>
                        <th className="py-4">سقف امتیاز</th>
                        <th className="py-4">امتیاز شغل</th>
                        {employeeScore && <th className="py-4">امتیاز شاغل</th>}
                    </tr>
                </thead>
                <tbody>
                    {
                        greadingData.map((i) => {
                            return <>
                                <tr className="bg-[#ffd4b6]">
                                    <th className="py-[8px]">{i?.name}</th>
                                    <th className="py-[8px]">{i?.score}</th>
                                    <th className="py-[8px]">{i?.jobScore}</th>
                                    {employeeScore && <th className="py-[8px]">{i?.employeeScore}</th>}
                                </tr>
                                {i.items.map((i) => {
                                    return (
                                        <tr className="">
                                            <td className="text-sm py-[4px] text-center">{i?.name}</td>
                                            <td className="text-sm py-[4px] text-center">{i?.score}</td>
                                            <td className="text-sm py-[4px] text-center">{i?.jobScore ? i?.jobScore : ""}</td>
                                            {employeeScore && <td className="text-sm py-[4px] text-center">{i?.employeeScore}</td>}
                                        </tr>
                                    )
                                })}

                            </>
                        })
                    }
                    <tr className="border border-gray-300">
                        <th className="py-4">جمع کل</th>
                        <th className="py-4">1000</th>
                        <th className="py-4">{+maharat + +masoliat + +kooshesh + +sharayet}</th>
                        {employeeScore && <th className="py-4"></th>}
                    </tr>
                </tbody>

            </table>

            {
                type == 2
                &&
                <span className="mt-10">
                    نظر کارشناس:
                </span>
            }
        </Page>
    )
}

export default GreadingPage